<template>
  <single-device 
    :device="singleDevice"
    :on-form-submitted="formSubmitted" />
</template>

<script>
import SingleDevice from '@/components/devices/SingleDevice';
import * as actions from '@/store/actions.type';
import { DASHBOARD_URL } from '@/router/constants';
import { 
  NOTIFICATION_ERROR,
  NOTIFICATION_SUCCESS
} from '@/common/event.types';
import {
  mapActions,
  mapGetters
} from 'vuex';

export default {
  name: 'EditDevice',
  computed: {
    ...mapGetters([
      'singleDevice',
      'loadingDevices',
      'settings'
    ]),
    deviceId() {
      return this.$route.params.id;
    }
  },
  mounted() {
    this.fetchSingleDeviceAction({ 
      deviceId: this.deviceId 
    })
  },
  destroyed() {
    this.resetSingleDeviceStateAction();
  },
  methods: {
    ...mapActions({
      fetchSingleDeviceAction: actions.FETCH_SINGLE_DEVICE,
      updateDeviceRequestAction: actions.UPDATE_DEVICE,
      resetSingleDeviceStateAction: actions.RESET_SINGLE_DEVICE_STATE
    }),
    formSubmitted(editedDevice) {
      this.updateDeviceRequestAction(editedDevice)
        .then(() => {
          this.$router.push(DASHBOARD_URL);

          this.$eventHub.$emit(NOTIFICATION_SUCCESS, {
            message: this.$t('device.notificatons.edited')
          })
        })
        .catch(({ data }) => {
          this.$eventHub.$emit(NOTIFICATION_ERROR, {
            message: data
          })
        })
    }
  },
  components: {
    SingleDevice
  }
}
</script>